module.exports = "https://static.energy5.com/_next/static/images/brand6-29e79bb104638232a3d85e493ad1e597.png";